/**
 * 品牌车系车型
 * @params Object
 *         {
 *             // 品牌
 *             vehicleBrand: String,
 *             // 车系
 *             vehicleSerial: String,
 *             // 车型
 *             vehicleType: String,   or   vehicleModel: String,
 *         }
 */
export default function vehicleBrandAndSerial({
    vehicleBrand = '',
    vehicleSerial = '',
    vehicleType = '',
    vehicleModel = '',
}) {
    const type = vehicleType || vehicleModel;
    return `${vehicleBrand || ''}${vehicleSerial || ''}${type || ''}`;
}
